import { Expansions, Patches, RAID_METADATA_BY_SLUG } from './enums';

export function getPatchIdForRaid(slug: string) {
  const raid = RAID_METADATA_BY_SLUG[slug];
  return raid?.patch || Patches.Unknown;
}

export function getExpansionIdForRaid(slug: string) {
  const raid = RAID_METADATA_BY_SLUG[slug];
  return raid?.expansion || Expansions.Current;
}

export function isCurrentExpansionRaid(slug: string) {
  const raid = RAID_METADATA_BY_SLUG[slug];
  return raid && raid.expansion === Expansions.Current;
}

export function isNextExpansionRaid(slug: string) {
  const raid = RAID_METADATA_BY_SLUG[slug];
  return raid && raid.expansion === Expansions.Next;
}
